// import React, { useState, useEffect } from "react";

// const DynamicInputFields = ({ label, name, placeholder, onFieldsChange,initialValues,disabled }) => {
//   const [inputFields, setInputFields] = useState(
//     initialValues?.length > 0
//       ? initialValues.map(value => ({ value, isDisabled: false }))
//       : [{ value: "", isDisabled: false }]
//   );

//   useEffect(() => {
//     if (initialValues?.length > 0) {
//       setInputFields(initialValues.map(value => ({ value, isDisabled: false })));
//     }
//   }, [initialValues]);
//   const [error, setError] = useState(null);

//   // Handle input field changes
//   const handleInputChange = (index, event) => {
//     const values = [...inputFields];
//     values[index].value = event.target.value;
//     setInputFields(values);
//     setError(null);
//     // Pass updated array to parent component
//     onFieldsChange(values.map(field => field.value));
//   };

//   // Add new field only if the previous one is not empty
//   const handleAddField = () => {
//     if (inputFields.length === 0) {
//       setInputFields([{ value: "", isDisabled: false }]);
//       setError(null);
//     } else {
//       const lastField = inputFields[inputFields.length - 1];
//       if (!lastField.value.trim()) {
//         setError("Please fill the previous field before adding a new one.");
//       } else {
//         const updatedFields = [
//           ...inputFields.map((f, i) => (i === inputFields.length - 1 ? { ...f, isDisabled: true } : f)),
//           { value: "", isDisabled: false },
//         ];
//         setInputFields(updatedFields);
//         setError(null);
//         // Update parent with new values
//         onFieldsChange(updatedFields.map(field => field.value));
//       }
//     }
//   };

//   // Remove a field
//   const handleRemoveField = (index) => {
//     const values = [...inputFields];
//     values.splice(index, 1);

//     if (values.length === 0) {
//       setInputFields([{ value: "", isDisabled: false }]);
//     } else if (index === inputFields.length - 1 && values.length > 0) {
//       values[values.length - 1].isDisabled = false;
//     }

//     setInputFields(values);
//     setError(null);
//     // Pass updated array to parent component
//     onFieldsChange(values.map(field => field.value));
//   };

//   return (
//     <div className="dynamic-input-fields">
//       {inputFields.map((field, index) => (
//         <div key={index} className="flex items-center gap-4 mb-2">
//           <input
//             type="text"
//             name={`${name}_${index}`}
//             value={field.value}
//             onChange={(e) => handleInputChange(index, e)}
//             placeholder={placeholder || `Enter ${label} ${index + 1}`}
//             disabled={disabled || field.isDisabled}
//             className={`bg-muted/40 h-10 w-full rounded-md text-base border px-3 manrope-fontCss ${
//               error && index === inputFields.length - 1 ? "border-red-500" : "border-[#3a5dd1] " 
//             } ${ disabled ? "opacity-50" : "border-[#3a5dd1]"}`}
//           />
//          {!disabled && <button
//             type="button"
//             onClick={() => handleRemoveField(index)}
//             className="bg-red-500 h-10 text-white rounded-md px-3"
//           >
//             Remove
//           </button>}
//         </div>
//       ))}

//       {error && (
//         <p className="text-red-500 text-sm mb-2">{error}</p>
//       )}

//      {!disabled && <button
//         type="button"
//         onClick={handleAddField}
//         className="bg-blue-500 h-10 text-white rounded-md px-4"
//       >
//         Add New {label}
//       </button>}
//     </div>
//   );
// };
import React, { useState, useRef } from "react";
import { MdOutlineFileUpload } from "react-icons/md";

const DynamicInputFields = ({ label, name, placeholder, onFieldsChange, initialValues, disabled }) => {
  const fileInputRefs = useRef([]);
  const [inputFields, setInputFields] = useState(
    initialValues?.length > 0
      ? initialValues.map((value) => ({ name: value.name || "", designation: value.designation || "", image: value.image || null }))
      : [{ name: "", designation: "", image: null }]
  );

  const [error, setError] = useState(null);

  // Handle file upload for image input
  const handleFileUpload = (index, event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      const updatedFields = [...inputFields];
      updatedFields[index].image = imageUrl; // Store the image URL in the corresponding field
      setInputFields(updatedFields);
      setError(null); // Clear the error if an image is uploaded
      onFieldsChange(updatedFields, file); // Pass the image file to the parent
    }
  };

  // Handle input field changes (for both name and designation)
  const handleInputChange = (index, event, fieldType) => {
    const values = [...inputFields];
    values[index][fieldType] = event.target.value;
    setInputFields(values);
    setError(null); // Clear the error when typing in the input
    onFieldsChange(values, null); // Update the parent with input field values
  };

  // Add a new field after ensuring all existing fields are filled
  const handleAddField = () => {
    const lastField = inputFields[inputFields.length - 1];
    // if (!lastField.name.trim() || !lastField.designation.trim() || !lastField.image)
    if (!lastField.name.trim() || !lastField.designation.trim()) {
      setError("Please complete the previous field before adding a new one.");
    } else {
      const updatedFields = [...inputFields, { name: "", designation: "", image: null }];
      setInputFields(updatedFields);
      setError(null);
      onFieldsChange(updatedFields, null); // Update the parent with the new set of values
    }
  };

  // Remove a field at a specific index
  const handleRemoveField = (index) => {
    const values = [...inputFields];
    values.splice(index, 1);

    if (values.length === 0) {
      setInputFields([{ name: "", designation: "", image: null }]); // Ensure at least one field exists
    } else {
      setInputFields(values);
    }

    setError(null);
    onFieldsChange(values, null); // Pass the updated values to the parent
  };

  return (
    <div className="dynamic-input-fields">
      {inputFields.map((field, index) => (
        <div key={index} className="flex items-center gap-4 mb-2 justify-center">
          {/* Profile picture upload */}
          {/* <div className="profile-pic-upload mb-4">
            <div>
              {field.image ? (
                <img
                  src={field.image}
                  alt="Profile"
                  className="w-36 h-16 rounded-full object-cover border cursor-pointer"
                  onClick={() => fileInputRefs.current[index].click()} // Click to change the image
                />
              ) : (
                <div
                  className="w-16 h-16 flex items-center justify-center bg-gray-200 rounded-full border cursor-pointer aspect-square"
                  onClick={() => fileInputRefs.current[index].click()}
                >
                  <MdOutlineFileUpload size={30} className="text-[#0D215C]" />
                </div>
              )}
              <input
                type="file"
                ref={(ref) => (fileInputRefs.current[index] = ref)}
                style={{ display: "none" }}
                onChange={(e) => handleFileUpload(index, e)}
                accept="image/*"
              />
            </div>
          </div> */}

          {/* Name input */}
          <input
            type="text"
            name={`${name}_name_${index}`}
            value={field.name}
            onChange={(e) => handleInputChange(index, e, "name")}
            placeholder={placeholder || `Enter ${label} Name ${index + 1}`}
            disabled={disabled}
            className={`bg-muted/40 h-10 w-full rounded-md text-base border px-3 manrope-fontCss ${
              error && index === inputFields.length - 1 ? "border-red-500" : "border-[#3a5dd1]"
            } ${disabled ? "opacity-50" : "border-[#3a5dd1]"}`}
          />

          {/* Designation input */}
          <input
            type="text"
            name={`${name}_designation_${index}`}
            value={field.designation}
            onChange={(e) => handleInputChange(index, e, "designation")}
            placeholder={`Enter ${label} Designation ${index + 1}`}
            disabled={disabled}
            className={`bg-muted/40 h-10 w-full rounded-md text-base border px-3 manrope-fontCss ${
              error && index === inputFields.length - 1 ? "border-red-500" : "border-[#3a5dd1]"
            } ${disabled ? "opacity-50" : "border-[#3a5dd1]"}`}
          />

          {/* Remove button */}
          {!disabled && (
            <button
              type="button"
              onClick={() => handleRemoveField(index)}
              className="bg-red-500 h-10 text-white rounded-md px-3"
            >
              Remove
            </button>
          )}
        </div>
      ))}

      {error && <p className="text-red-500 text-sm mb-2">{error}</p>}

      {/* Add new field button */}
      {!disabled && (
        <button
          type="button"
          onClick={handleAddField}
          className="bg-blue-500 h-10 text-white rounded-md px-4"
        >
          Add New {label}
        </button>
      )}
    </div>
  );
};

export default DynamicInputFields;
